<template>
  <div class="bg-white border border-gray-200 overflow-hidden rounded shadow-sm text-gray-800">
    <div class="px-4 py-6 sm:px-6">

      <div class="flex flex-row justify-start items-center">
        <div
          class="h-2.5 w-2.5 my-1 rounded-full"
          :class="bgColors(status.type)"
        >
        </div>
        <h1
          class="text-xl ml-2 leading-6 font-medium tracking-wide"
          :class="textColors(status.type)"
        >
          {{ status.name }}
        </h1>
      </div>

      <p class="mt-6 max-w-2xl text-sm font-bold tracking-wide">{{ ticket.title }}</p>
      <p v-if="ticket.cod" class="mt-1 max-w-2xl text-sm tracking-wide">#{{ ticket.cod }}</p>

      <div class="w-full my-4 border-t border-gray-200" v-if="orderItems.length" />

      <div class="flex" v-if="orderItems.length">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
          <path d="M3 1a1 1 0 000 2h1.22l.305 1.222a.997.997 0 00.01.042l1.358 5.43-.893.892C3.74 11.846 4.632 14 6.414 14H15a1 1 0 000-2H6.414l1-1H14a1 1 0 00.894-.553l3-6A1 1 0 0017 3H6.28l-.31-1.243A1 1 0 005 1H3zM16 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM6.5 18a1.5 1.5 0 100-3 1.5 1.5 0 000 3z" />
        </svg>

        <span class="ml-2 font-bold text-sm tracking-wide">Itens relacionados a esse ticket de atendimento</span>
      </div>

      <div class="mt-2" v-if="orderItems.length">
        <ExternalOrderItem
          v-for="(orderItem, key) in orderItems"
          :key="key"
          :order-item="orderItem"
          :organization="organization"
        />
      </div>
    </div>

  </div>
</template>

<script>
import ExternalOrderItem from '@/components/ExternalOrderItem'
import { findOne as ticketFindOne } from '@/repositories/integrations/mobly/services/csExternal/ticket'

export default {
  name: 'ExternalOrderItemList',
  components: {
    ExternalOrderItem
  },
  props: {
    ticketId: String,
    status: Object,
    organization: String
  },
  data () {
    return {
      orderItems: [],
      ticket: {},
      snackBar: {
        show: false,
        position: 'left',
        message: '',
        closeMessage: '',
        icon: true,
        duration: 3000
      },
      loading: false
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    async init () {
      await this.getTicket()
    },
    async getTicket () {
      try {
        this.loading = true

        const ticket = await ticketFindOne(this.ticketId, '', this.organization)

        if (ticket.data.orderItem && ticket.data.orderItem.length) {
          this.orderItems = ticket.data.orderItem
        }

        this.ticket = ticket.data

        this.loading = false
      } catch (error) {
        this.loading = false

        this.snackBar.show = true
        this.snackBar.message = error.response.data.message
      }
    },

    textColors (type) {
      const colors = {
        default: 'text-black',
        awaiting_mobly: 'text-blue-organization',
        awaiting_customer: 'text-orange-organization-pending',
        canceled: 'text-gray-organization',
        done: 'text-green-organization'
      }

      return colors[type]
    },

    bgColors (type) {
      const colors = {
        default: 'bg-black',
        awaiting_mobly: 'bg-blue-organization',
        awaiting_customer: 'bg-orange-organization-pending',
        canceled: 'bg-gray-organization',
        done: 'bg-green-organization'
      }

      return colors[type]
    }
  }
}
</script>
